const explodeSeriesNumber = (seriesNumberString) => {
    const exploded = seriesNumberString.trim().split(' ');
    return {series: exploded[0] ?? '', number: exploded[1] ?? ''}
}

export default explodeSeriesNumber;